import {
    ComposedChart, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
    Bar, Line, Brush
} from 'recharts';
import { useState, useEffect } from 'react';
import { calculateSMA, calculateRSI } from './utils/indicators';
import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";

function StockCandlestickChart({ symbol }) {
    const [data, setData] = useState([]);
    const [interval, setInterval] = useState("day"); // 1D, 1M etc.

    useEffect(() => {
        const fetchData = async () => {
            try {
                const today = new Date();
                const to = today.toISOString().split("T")[0];
                const from = new Date(today.getTime() - 180 * 24 * 60 * 60 * 1000).toISOString().split("T")[0]; // last 180 days

                const qs = new URLSearchParams(
                    Object.fromEntries(Object.entries({ symbol, interval, from, to }).filter(([, v]) => v != null && v !== ""))
                ).toString();

                const res = await fetch(`/api/chart-data?${qs}`);
                const data = await res.json();
                setData(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Failed to fetch chart data:", err);
                setData([]);
            }
        };

        fetchData();
    }, [symbol, interval]);

    return (
        <>
            <div className="flex gap-2 mb-4">
                {["1D", "1M", "6M", "1Y", "5Y", "ALL"].map(tf => (
                    <button key={tf} onClick={() => setInterval(mapTimeframeToInterval(tf))}>
                        {tf}
                    </button>
                ))}
            </div>

            <ResponsiveContainer width="100%" height={400}>
                <ComposedChart data={data}>
                    <CartesianGrid stroke="#ccc" />
                    <XAxis dataKey="time" />
                    <YAxis yAxisId="left" />
                    <YAxis yAxisId="right" orientation="right" hide />
                    <Tooltip />

                    {/* OHLC Candlestick */}
                    {data.map((entry, index) => {
                        const color = entry.close > entry.open ? "#4caf50" : "#f44336";
                        return (
                            <g key={index}>
                                {/* Wick */}
                                <line
                                    x1={index * 10} x2={index * 10}
                                    y1={entry.high} y2={entry.low}
                                    stroke={color} strokeWidth={1}
                                />
                                {/* Body */}
                                <rect
                                    x={index * 10 - 2}
                                    y={Math.min(entry.open, entry.close)}
                                    width={4}
                                    height={Math.abs(entry.open - entry.close)}
                                    fill={color}
                                />
                            </g>
                        );
                    })}

                    {/* Volume Bar */}
                    <Bar yAxisId="right" dataKey="volume" barSize={10} fill="#82ca9d" />
                    <Brush dataKey="time" height={30} stroke="#8884d8" />
                </ComposedChart>
            </ResponsiveContainer>
        </>
    );
}

function mapTimeframeToInterval(tf) {
    switch (tf) {
        case "1D": return "5minute";
        case "1M": return "day";
        case "6M": return "day";
        case "1Y": return "day";
        case "5Y": return "week";
        case "ALL": return "month";
        default: return "day";
    }
}

export default StockCandlestickChart;
